import styled from 'styled-components';

import {
  Button as ButtonLayoutComponent, Header as HeaderLayoutComponent, Segment as SegmentLayoutComponent, Text as TextLayoutComponent,
} from '@playbookux/playbook-web-core';

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

export const Segment = styled(SegmentLayoutComponent)`
  &.ui.segment {
    display: flex;
    flex-direction: column;
    margin-top: 100px;
    padding: 30px;
    width: 665px;
  }
`;

export const Video = styled.iframe`
  position:absolute;
  top:0;
  left:0;
  width:100%;
  height:100%;
`;

export const VideoContainer = styled.div`
  padding: 56.25% 0 0 0;
  position:relative;
`;

export const Text = styled(TextLayoutComponent)``;

export const Header = styled(HeaderLayoutComponent)`
  margin-bottom: 20px;
`;

export const ButtonArea = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Button = styled(ButtonLayoutComponent)`
  &.ui.button {
    align-self: center;
    width: 100px;
    margin: 10px 0;
  }
`;

export const Link = styled.a``;
